"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function find(list, predicate) {
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return list[i];
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/find.js
// module id = 48
// module chunks = 34471704633725 35783957827783 216468464745311